<template>
  <div>
    <b-modal id="bv-modal-view-email" size="lg" hide-footer hide-header>
        <div class="row">
        <div class="col pt-3">
            <div><small><b>From:</b> {{email.sender_name}} - {{email.sender_email}}</small></div>
            <div><small><b>To:</b> {{email.name}} - {{email.email}}</small></div>
            <div><small><b>Subject:</b> {{email.subject}}</small></div>
            <div><hr size="1"></div>
            <div class="mb-4"><a href="https://supalytic.com" target="_blank"><img src="https://res.cloudinary.com/web900/image/upload/v1748986439/supalytic_b83mvh.png" width="120"></a></div>
            <p v-if="email.content" v-html="formatEmail(email.content)"></p>
        </div>
      </div>

    </b-modal>
  </div>
</template> 

<script>
export default {
  props: ['email'],

  data() {
    return {

    };
  },

  created() {
    
  },

  methods: {

      hideModal() {
        this.$bvModal.hide("bv-modal-view-email");
      },

      formatEmail(content) {
        return content.replace(/<br><br>/g, '<br>');
      },

  },
};
</script>

<style scoped>
.modal-dialog {
  max-width: 50% !important;
}

label.form-label {
  font-weight: 600 !important;
  text-align: center;
  display: block;
}
input.form-control {
    text-align: center;
}

.btn.btn-danger.submit, .btn.btn-secondary.submit, input.form-control {
    border-radius: 5px !important;
}
</style>